import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { initTelemetry } from './lib/telemetry'
import './index.css'

// Initialize PostHog before the first render so session_started fires
// against a clean session. Env-gated: if VITE_POSTHOG_API_KEY is absent
// the module silently no-ops and every Telemetry.* call becomes a
// cheap early return.
initTelemetry()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
